import React from "react";

import OnlineToggle from "./components/OnlineToggle";
import WaitingScreen from "./components/WaitingScreen";
import PizzaTimerIntegracao from "./components/PizzaTimerIntegracao";
import Modal from "../../components/Modal";
import RodizioModal from "./components/RodizioModal";
import SalaoModal from "./components/SalaoModal";
import PizzaTimer from "../Pizzaiolo/components/PizzaTimer";
import { formatTime } from "../Pizzaiolo/utils/timeUtils";
import { getPizzaIcon } from "../Pizzaiolo/utils/pizzaUtils";

import {
  PizzaioloIntegracaoProvider,
  usePizzaioloIntegracao,
} from "./context/PizzaioloIntegracaoContext";

const PizzaioloIntegracaoContent: React.FC = () => {
  const {
    isOnline,
    isFilaSalgada,
    isFilaDoce,
    isFilaSalaoSalgada,
    isFilaSalaoDoce,
    isFilaRodizioSalgada,
    isFilaRodizioDoce,
    currentItem,
    timeElapsed,
    isFinalizing,
    isPulando,
    isTogglingOnline,
    isLoadingStatus,
    pendingSalgada,
    pendingDoce,
    pendingSalaoSalgada,
    pendingSalaoDoce,
    isRodizioModalOpen,
    isSalaoModalOpen,
    tamanhosRodizio,
    tamanhosSalao,
    bordasSalao,
    isLoadingTamanhosRodizio,
    isLoadingSalaoOptions,
    isCreatingRodizio,
    isRodizioSalgadoTimerActive,
    rodizioSalgadoLabel,
    rodizioSalgadoTimeElapsed,
    isFinalizingRodizioSalgado,
    isSalaoTimerActive,
    salaoLabel,
    salaoTimeElapsed,
    isFinalizingSalao,
    handleToggleOnline,
    handleFinalizarProximo,
    handleFinalizarOffline,
    openRodizioModal,
    openSalaoModal,
    closeRodizioModal,
    closeSalaoModal,
    handleCriarRodizio,
    handleStartRodizioSalgadoTimer,
    handleFinalizarRodizioSalgadoTimer,
    handleStartSalaoTimer,
    handleFinalizarSalaoTimer,
    handlePularItem,
    handleDefinirTamanhoRodizio,
    isDefinindoTamanhoRodizio,
  } = usePizzaioloIntegracao();

  if (isLoadingStatus) {
    return (
      <main className="mx-auto flex min-h-[70vh] max-w-7xl items-center justify-center py-6 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          <p className="text-lg text-neutral-600">Carregando...</p>
        </div>
      </main>
    );
  }

  return (
    <main className="mx-auto max-w-7xl py-6 sm:px-6 lg:px-8">
      <div className="px-4">
        <OnlineToggle
          isOnline={isOnline}
          isToggling={isTogglingOnline}
          isFilaSalgada={isFilaSalgada}
          isFilaDoce={isFilaDoce}
          isFilaSalaoSalgada={isFilaSalaoSalgada}
          isFilaSalaoDoce={isFilaSalaoDoce}
          isFilaRodizioSalgada={isFilaRodizioSalgada}
          isFilaRodizioDoce={isFilaRodizioDoce}
          onToggle={handleToggleOnline}
          onOpenRodizio={openRodizioModal}
          onOpenSalao={openSalaoModal}
        />

        {isRodizioSalgadoTimerActive ? (
          <div className="animate-fadeInUp px-4 pt-8">
            <PizzaTimer
              activeTimer={rodizioSalgadoLabel}
              timeElapsed={rodizioSalgadoTimeElapsed}
              isFinalizing={isFinalizingRodizioSalgado}
              onStop={handleFinalizarRodizioSalgadoTimer}
              getPizzaIcon={getPizzaIcon}
              formatTime={formatTime}
            />
          </div>
        ) : isSalaoTimerActive ? (
          <div className="animate-fadeInUp px-4 pt-8">
            <PizzaTimer
              activeTimer={salaoLabel}
              timeElapsed={salaoTimeElapsed}
              isFinalizing={isFinalizingSalao}
              onStop={handleFinalizarSalaoTimer}
              getPizzaIcon={getPizzaIcon}
              formatTime={formatTime}
            />
          </div>
        ) : !isOnline ? (
          <OfflineScreen
            isFilaSalgada={isFilaSalgada}
            isFilaDoce={isFilaDoce}
            isFilaSalaoSalgada={isFilaSalaoSalgada}
            isFilaSalaoDoce={isFilaSalaoDoce}
            isFilaRodizioSalgada={isFilaRodizioSalgada}
            isFilaRodizioDoce={isFilaRodizioDoce}
          />
        ) : currentItem ? (
          <div className="animate-fadeInUp pt-6">
            <PizzaTimerIntegracao
              item={currentItem}
              timeElapsed={timeElapsed}
              isFinalizing={isFinalizing}
              isPulando={isPulando}
              isDefinindoTamanhoRodizio={isDefinindoTamanhoRodizio}
              onFinalizarProximo={handleFinalizarProximo}
              onFinalizarOffline={handleFinalizarOffline}
              onPularItem={handlePularItem}
              onDefinirTamanhoRodizio={handleDefinirTamanhoRodizio}
            />
          </div>
        ) : (
          <WaitingScreen
            pendingSalgada={pendingSalgada}
            pendingDoce={pendingDoce}
            pendingSalaoSalgada={pendingSalaoSalgada}
            pendingSalaoDoce={pendingSalaoDoce}
            isFilaSalgada={isFilaSalgada}
            isFilaDoce={isFilaDoce}
            isFilaSalaoSalgada={isFilaSalaoSalgada}
            isFilaSalaoDoce={isFilaSalaoDoce}
            isFilaRodizioSalgada={isFilaRodizioSalgada}
            isFilaRodizioDoce={isFilaRodizioDoce}
          />
        )}
      </div>

      <Modal
        isOpen={isRodizioModalOpen}
        onClose={closeRodizioModal}
        title="Registrar Rodízio"
      >
        <RodizioModal
          tamanhos={tamanhosRodizio}
          isLoadingTamanhos={isLoadingTamanhosRodizio}
          isSavingDoce={isCreatingRodizio}
          onCancel={closeRodizioModal}
          onSubmitDoce={handleCriarRodizio}
          onStartSalgadoTimer={handleStartRodizioSalgadoTimer}
        />
      </Modal>

      <Modal isOpen={isSalaoModalOpen} onClose={closeSalaoModal} title="Salão">
        <SalaoModal
          tamanhosSalao={tamanhosSalao}
          bordas={bordasSalao}
          isLoading={isLoadingSalaoOptions}
          onCancel={closeSalaoModal}
          onStartTimer={handleStartSalaoTimer}
        />
      </Modal>
    </main>
  );
};

const OfflineScreen: React.FC<{
  isFilaSalgada: boolean;
  isFilaDoce: boolean;
  isFilaSalaoSalgada: boolean;
  isFilaSalaoDoce: boolean;
  isFilaRodizioSalgada: boolean;
  isFilaRodizioDoce: boolean;
}> = ({
  isFilaSalgada,
  isFilaDoce,
  isFilaSalaoSalgada,
  isFilaSalaoDoce,
  isFilaRodizioSalgada,
  isFilaRodizioDoce,
}) => {
  const hasAccess =
    isFilaSalgada ||
    isFilaDoce ||
    isFilaSalaoSalgada ||
    isFilaSalaoDoce ||
    isFilaRodizioSalgada ||
    isFilaRodizioDoce;

  return (
    <div className="mt-12 text-center">
      <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-neutral-100">
        <span className="text-5xl">🍕</span>
      </div>
      <h2 className="mb-2 text-2xl font-bold text-neutral-700">
        Você está inativo nas filas
      </h2>
      {hasAccess ? (
        <p className="text-neutral-500">
          Fique ativo nas filas para receber pedidos automaticamente.
        </p>
      ) : (
        <div className="mx-auto max-w-md rounded-xl border-2 border-yellow-200 bg-yellow-50 p-4">
          <p className="font-semibold text-yellow-800">Sem acesso a filas</p>
          <p className="mt-1 text-sm text-yellow-600">
            Ative pelo menos uma fila em Meu Perfil (cardápio, salão ou
            rodízio) e depois clique em Ficar Ativo.
          </p>
        </div>
      )}
    </div>
  );
};

const PizzaioloIntegracao: React.FC = () => {
  return (
    <PizzaioloIntegracaoProvider>
      <PizzaioloIntegracaoContent />
    </PizzaioloIntegracaoProvider>
  );
};

export default PizzaioloIntegracao;
